import React from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import './menuList.scss'

library.add(faPlus);
export default function MenuList(props) {
    const { info } = props;
    return (
        <div id={info.id} className='menuList'>
            <Link to={info.url}>
                <FontAwesomeIcon icon='plus'/>
                <span>{info.text}</span>
            </Link>
        </div>
    )

}
